import React, { useState, useEffect } from 'react';
import { studentTimeTable } from '../../redux/action/studentAction';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import HomeHelper from '../../Components/HomeHelper';
import '../../Style/StuResult.css';
import Footer from '../../Components/Footer';
import Loading from '../../Components/Loading';

const StudentTimeTable = () => {
  const store = useSelector((store) => store);
  const history = useHistory();
  const dispatch = useDispatch();
  const [error, setError] = useState({});

  useEffect(() => {
    // Dispatch action to fetch timetable data when the component mounts
    dispatch(studentTimeTable());
  }, []);

  useEffect(() => {
    if (store.errorHelper) {
      setError(store.errorHelper);
    }
  }, [store.errorHelper]);

  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

  const periods = [
    '1st Period  <small>(9:00 to 9:55)</small>',
    '2nd Period  <small>(9:55 to 10:50)</small>',
    '3rd Period  <small>(11:05 to 11:55)</small>',
    '4th Period  <small>(12:55 to 12:45)</small>',
    '5th Period  <small>(1:15 to 2:10)</small>',
    '6th Period  <small>(2:10 to 3:00)</small>',
    '7th Period  <small>(3:10 to 4:00)</small>',
    'Coaching  <small>(4:10 to 5:30)</small>'
  ];
  
  const isTimetableDataAvailable = store.student.timetableData && store.student.timetableData.length > 0;

  return (
    <div>
      {store.student.isAuthenticated ? (
        <>
          <HomeHelper />
          <div
            className="container-fluid main"
            style={{ backgroundImage: 'url("/image/pattern.png")', backgroundRepeat: 'repeat' }}
          >
            <div className='px-4 py-1 bg-light d-flex align-items-center justify-content-between'>
                            <h3 className='d-flex align-items-center justify-content-between'> <img src="/logo192.png" width={'40px'} alt="" /> TimeTable</h3>
                            <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                        </div>
                        
            <div className="row mt-3">
              <div className="col-md-11 m-auto">
                <div className='resultT p-2'>
                  <h2 className='text-center'>TimeTable</h2><br />
                 <div className='d-flex align-items-center justify-content-around '> <h5>Department :{store.student.student.student.department} </h5>
                            <h5>Year :{store.student.student.student.year} </h5>
                            <h5>Semester:{store.student.student.student.semester} </h5>
                            <h5>Section:{store.student.student.student.section} </h5></div>
                </div>
                  <table className="table resultT p-2 table-responsive table-striped table-bordered">
                    <thead>
                      <tr className="table resultTcol text-light">
                        <th  width="10%">Day</th>
                        {periods.map((period, index) => (
                          <th width="10%" key={index}><span dangerouslySetInnerHTML={{ __html: period }} /></th>
                          ))}
                      </tr>
                    </thead>
                    {isTimetableDataAvailable ? ( 
                    <tbody>
                      {daysOfWeek.map((day, dayIndex) => (
                        <tr key={dayIndex}>
                          <td>{day}</td>
                          {periods.map((period, periodIndex) => {
                            // Find the corresponding timetable entry
                            const timetableEntry = store.student.timetableData[0].timetable.find(
                              (entry) => entry.day === day && entry.periods[periodIndex].periodName === `${periodIndex + 1}st Period`
                            );
                            return (
                              <td key={periodIndex}>
                                {timetableEntry ? timetableEntry.periods[periodIndex].content : 'No data available'}
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <Loading />
                      
                  )}
                  </table>
              </div>
            </div>
          </div>
        </>
      ) : (
        history.push('/')
      )}
      <Footer />
    </div>
  );
};

export default StudentTimeTable;
